export default __webpack_public_path__ + "static/media/favicon.c08858f0.ico";